import {
  IAgoraRTCRemoteUser,
  ICameraVideoTrack,
  ILocalAudioTrack,
  ILocalVideoTrack,
  IMicrophoneAudioTrack,
} from 'agora-rtc-sdk-ng';
import { makeAutoObservable, toJS } from 'mobx';
import * as Agora from '../hooks/constants';
import { cacheService } from '../../../services/cacheService';
import { globalStore } from '../../../global.store';

const { enabled, notFound, disabled } = Agora.MEDIA_DEVICE_STATUS;
class Agoratemplate {
  toggleScreen = false;

  videoTracks: any = {};

  enableSound: string = disabled;

  enableVideo: string = disabled;

  micLoading = false;

  videoLoading = false;

  screenTrack: any = {};

  remoteUsersVideo: IAgoraRTCRemoteUser[] = [];

  remoteUsersAudio: IAgoraRTCRemoteUser[] = [];

  remoteUsersScreen: IAgoraRTCRemoteUser[] = [];

  permissionAudio: any = [];

  localAudioTrack: IMicrophoneAudioTrack | undefined = undefined;

  localVideoTrack: ILocalVideoTrack | undefined = undefined;

  localScreenTrack: ILocalVideoTrack | undefined = undefined;

  speakerList: any = {};

  constructor() {
    makeAutoObservable(this);
  }

  get videos() {
    return this.remoteUsersAudio;
  }

  get micEnabled() {
    return this.enableSound === enabled;
  }

  get videoEnabled() {
    return this.enableVideo === enabled;
  }

  setVideoTracks = (id: any, videoTrack: any) => {
    this.videoTracks = { ...this.videoTracks, [id]: videoTrack };
  };

  setScreenTracks = (screenTrack: ILocalVideoTrack) => {
    this.videoTracks = screenTrack;
  };

  setMicStatus = (status: string) => {
    this.enableSound = status;
  };

  setIsLoadingMic = (flag: boolean) => {
    this.micLoading = flag;
  };

  setVideoStatus = (status: string) => {
    this.enableVideo = status;
  };

  setIsLoadingVideo = (flag: boolean) => {
    this.videoLoading = flag;
  };

  setLocalAudioTrack = (track: IMicrophoneAudioTrack | undefined) => {
    this.localAudioTrack = track;
  };

  setLocalVideoTrack = (track: ICameraVideoTrack | undefined) => {
    const videoTextureId = `${Math.floor(cacheService.getMyId / 2)}`;
    this.setVideoTracks(videoTextureId, track);
    this.localVideoTrack = track;
  };

  setLocalScreenTrack = (track: ILocalVideoTrack) => {
    const videoTextureId = `${Math.floor(cacheService.getMyId / 3)}`;
    this.localScreenTrack = track;
    this.setVideoTracks(videoTextureId, track);
  };

  setRemoteUsersVideo = (stream: IAgoraRTCRemoteUser[]) => {
    this.remoteUsersVideo = [...stream];
  };

  setRemoteUsersAudio = (stream: IAgoraRTCRemoteUser[]) => {
    this.remoteUsersAudio = [...stream];
  };

  setRemoteUsersScreen = (stream: IAgoraRTCRemoteUser[]) => {
    this.remoteUsersScreen = [...stream];
  };

  setSpeakerList = (obj: any) => {
    this.speakerList = obj;
  };

  setScreenShare = (bool: boolean) => {
    this.toggleScreen = bool;
  };

  getVideos = () => this.videoTracks;

  errorhandlerMicPermission = (e: any) => {
    switch (e.message) {
      case 'Not Found':
        globalStore.setToasts(true, 'mic_not_found');
        break;
      case 'Permission':
        globalStore.setToasts(true, 'mic_permission');
        break;
      default:
        break;
    }
    console.warn('ERROR: in enable audio', e.message);
  };
}
export const agoraStore = new Agoratemplate();
